/* AUTOMATSKO OBNAVLJANJE PRIJAVE (29.10.2026, Miloš: nadzorni centar gleda non-stop,
   ne sme da ga odjavljuje).
   Dok je stranica otvorena: pri otvaranju, pri povratku na karticu i zatim na svaki sat
   proverava prijavu; ako je starija od 12 h, traži novu preko /token/refresh.
   Obnova MORA pre isteka: lds-auth istekle prijave odbija (401, provereno 29.10), a
   prijava traje 30 dana (jwt.age u backendu), pa ima dovoljno vremena.
   Ako obnova ne uspe (mreža, server), stara prijava i dalje važi i pokušava se ponovo
   za sat, nema štete. Dok i dron ovo ne koriste: imaju svoj MQTT nalog. */
import { CURRENT_CONFIG } from '/@/api/http/config'
import { ELocalStorageKey } from '/@/types/enums'

const PROVERA_MS = 60 * 60 * 1000
const OBNOVI_POSLE_S = 12 * 3600

function citaj (token: string): { iat?: number, exp?: number } | null {
  try {
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
  } catch {
    return null
  }
}

let radi = false
async function obnovi () {
  if (radi) return
  const token = localStorage.getItem(ELocalStorageKey.Token)
  if (!token) return
  const p = citaj(token)
  const sada = Date.now() / 1000
  if (!p || !p.exp || p.exp <= sada) return // istekla: server je ne prima, traži se nova prijava
  if (p.iat && sada - p.iat < OBNOVI_POSLE_S) return // sveža, nema potrebe
  radi = true
  try {
    const r = await fetch(`${CURRENT_CONFIG.baseURL}manage/api/v1/token/refresh`, {
      method: 'POST',
      headers: { [ELocalStorageKey.Token]: token, 'Content-Type': 'application/json' },
      body: '{}',
    })
    const j = await r.json()
    const novi = j?.code === 0 ? j?.data?.access_token : null
    // druga kartica je možda već obnovila: ne gazimo noviju prijavu
    if (novi && localStorage.getItem(ELocalStorageKey.Token) === token) {
      localStorage.setItem(ELocalStorageKey.Token, novi)
    }
  } catch {
    // mreža ili server: stara prijava važi, probaće ponovo za sat
  } finally {
    radi = false
  }
}

export function pokreniObnovuPrijave () {
  obnovi()
  window.setInterval(obnovi, PROVERA_MS)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') obnovi()
  })
}
